// extracted by mini-css-extract-plugin
export var gridText = "GridText-module--gridText--e84a3";
export var gridTextContainer = "GridText-module--gridTextContainer--8ba2f";
export var mobileReverseOrder = "GridText-module--mobileReverseOrder--5af37";